// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"737":"920092f3","1872":"e8cd3544","1946":"7534b161","4212":"a28fb3c4","5728":"cfa49888","6118":"f2c13a74","7182":"c16f55f2"}[chunkId] + ".css";
};